var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.15146 20.5969L0.351457 12.7969C-0.117152 12.3282 -0.117152 11.5684 0.351457 11.0998L2.04847 9.40273C2.51708 8.93407 3.27693 8.93407 3.74553 9.40273L8.99999 14.6571L20.2544 3.40273C20.7231 2.93412 21.4829 2.93412 21.9515 3.40273L23.6485 5.09979C24.1171 5.5684 24.1171 6.32819 23.6485 6.79685L9.84852 20.5969C9.37986 21.0655 8.62007 21.0655 8.15146 20.5969Z",
    fill: "#23B100"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.057456352b5c5f506e36e668f86c4bbb.svg";
export { ForwardRef as ReactComponent };